import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from "rxjs";
import { SubscribeService } from 'rs-ng-core';
@Component({
  selector: 'lib-rs-ng-button-line',
  templateUrl: './rs-ng-button-line.component.html',
  styleUrls: ['./rs-ng-button-line.component.scss']
})
export class RsNgButtonLineComponent implements OnInit {
  @Input() data = {}
  @Input() title = ""
  @Input() listData = []
  @Input() isBindTreeNodeSubject = false;//çå¬treeç»ä»¶

  @Input() styleName = "style1"
  @Input() itemPadding="0.5rem 0"
  // @Input() params = { data: [], title: "" };
  treeNodeSubscription = new Subscription();
  isShow = true;
  constructor(private subscribeService: SubscribeService,) {

  }
  ngOnDestroy(): void {
    this.treeNodeSubscription && this.treeNodeSubscription.unsubscribe();

  }

  getClass(i) {
    return i < this.listData.length - 1 ? 'line' : ''
  }
  ngOnInit(): void {
    this.listen();


  }

  listen() {
    if (this.isBindTreeNodeSubject) {
      this.treeNodeSubscription = this.subscribeService.treeNodeSubject.subscribe(node => {

        console.log(node, 'node');

        this.bandleShow()

      });
    }

  }

  bandleShow() {
    this.isShow = false
    setTimeout(() => {
      this.isShow = true
    }, 1000)
  }

}
